import handleOnUnload from '../../helpers/handleOnUnload';

const redirect = ({ href }) => {
  window.removeEventListener('beforeunload', handleOnUnload);
  window.location = href;
  return null;
};

export default redirect;
